import codesnippet_big from '../img/codesnippet_big.png'
import codesnippet_icon from '../img/codesnippet_icon.png'
import componentsBrowser  from '../img/components-browser.png'


import documents  from '../img/documents.png'
import register  from '../img/register.png'

import usericon  from '../img/user-icon.png'

const codeSnippet = {
    big: codesnippet_big,
    icon: codesnippet_icon
}

const advertisment = { 
    browser: componentsBrowser
}

const various = {
    documents:documents,
    register:register
}

const snippetImg = {
    usericon: usericon
}

export {
    codeSnippet,
    advertisment,
    various,
    snippetImg
}